import {useBrand} from '@/contexts/BrandContext';
import {ArkLoader, CortileLoader} from '@ark/web';

export const BrandLoader = () => {
  const {key, resolved} = useBrand();
  if (!resolved) return null;
  if (key === 'cortile') return <CortileLoader />;
  return <ArkLoader />;
};
